import type { UnitSearchResult } from '../api/types'
import { Button, Card, Row, RowMeta, RowTitle } from './ui'

/**
 * Disambiguation list.
 *
 * A landlord or managing agent legitimately maps to several units, so `unit-search`
 * returning multiple rows is normal rather than an error.
 */
export function UnitPicker({
    matches,
    intro,
    onSelect,
    onSearchInstead,
}: {
    matches: UnitSearchResult[]
    intro: React.ReactNode
    onSelect: (unit: UnitSearchResult) => void
    onSearchInstead?: () => void
}) {
    return (
        <>
            <p className="mb-2 mt-0 px-0.5 text-[11px] text-foreground/60">{intro}</p>
            <Card>
                <div className="px-2.5 py-1">
                    {matches.map((match) => (
                        <div key={`${match.block_id}-${match.unit_id}`} className="border-t border-border first:border-t-0">
                            <button
                                type="button"
                                onClick={() => onSelect(match)}
                                className="-mx-2.5 block w-[calc(100%+1.25rem)] px-2.5 py-1 text-left hover:bg-background"
                            >
                                <Row
                                    main={
                                        <>
                                            <RowTitle>{match.unit_name}</RowTitle>
                                            <RowMeta>
                                                {[
                                                    match.block_name,
                                                    match.block_reference,
                                                    match.person_company_name,
                                                ]
                                                    .filter(Boolean)
                                                    .join(' · ')}
                                            </RowMeta>
                                        </>
                                    }
                                />
                            </button>
                        </div>
                    ))}
                </div>
            </Card>
            {onSearchInstead && (
                <Button variant="outline" onClick={onSearchInstead}>
                    Search all units instead
                </Button>
            )}
        </>
    )
}
